import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import AppMobile from './AppMobile.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import 'ol/ol.css';
import router from './route.js'

import gv from './mixins/globalValiables.js'
import isMobile from 'ismobilejs'
import "./assets/css/drawer.scss";


Vue.mixin(gv)    // mixinに登録

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

const userAgent = navigator.userAgent;
console.log(isMobile(userAgent).phone);

Vue.prototype.$isMobileAny = isMobile(userAgent).phone;
// Vue.prototype.$isMobileAny = true;
if(Vue.prototype.$isMobileAny) {
	// スマホ or タブレットの処理
	new Vue({
		router,
		el: '#app',
		render: h => h(AppMobile),
		data: {
		saveLayers:[] //選択済みレイヤー
		},
		created: function() {
		console.log('スマホ:'+Vue.prototype.$isMobileAny);
		}
	})
} else {
	// スマホ、タブレット以外の処理
	new Vue({
		router,
		el: '#app',
		render: h => h(App),
		created: function() {
		console.log('PC:'+Vue.prototype.$isMobileAny);
		}
	})
}
